import { useIntl } from 'react-intl';

import { RadioButtonSize, RadioButton, Tooltip } from '@verantos-dev/shared-components';
import { CohortBuilderModalLegacy } from '@verantos-dev/types-cohorts';

import { getShouldShowFieldError } from '../../utils/getShouldShowFieldError';
import { CohortBuilderEditModalFilter } from '../CohortBuilderEditModal/CohortBuilderEditModalFilter/CohortBuilderEditModalFilter';
import {
  CohortBuilderInputField,
  type CohortBuilderInputFieldProps,
} from '../CohortBuilderInputField/CohortBuilderInputField';

export type CohortBuilderEditModalEventProps = {
  /**
   * @prop {string} - id of the filter component
   */
  id: string;

  // eventName: CohortBuilderInputFieldProps;

  // eventDate: CohortBuilderInputFieldProps | undefined;

  fields: CohortBuilderInputFieldProps[];

  selection?: CohortBuilderInputFieldProps;

  /**
   * @prop {function} - function to call when the remove filter button is clicked
   * @param {string} - id of the filter component
   */
  onRemoveEvent?: (id: string) => void;

  /**
   * @prop {boolean} - whether or not the remove button is enabled
   * @default false
   */
  isRemoveEnabled?: boolean;

  position?: CohortBuilderInputFieldProps;

  index?: CohortBuilderInputFieldProps;

  eventFilterTitleText?: string;

  viewMode?: boolean;

  modal?: CohortBuilderModalLegacy;
  updateFieldError?: (id: string, error?: string) => void;
};

export const CohortBuilderEditModalEvent = ({
  id,
  fields,
  selection,
  eventFilterTitleText,
  isRemoveEnabled = false,
  onRemoveEvent,
  viewMode = false,
  modal,
  updateFieldError,
}: CohortBuilderEditModalEventProps) => {
  const intl = useIntl();
  const onRemoveFilterHandler = () => {
    onRemoveEvent && onRemoveEvent(id);
  };

  return (
    <Tooltip
      id={`cohortBuilderEditModalEvent-${id}-tooltip`}
      arrow
      key={id}
      title={eventFilterTitleText}
    >
      <CohortBuilderEditModalFilter
        id={`cohortBuilderEditModalEvent-${id}`}
        disableRemove={!isRemoveEnabled}
        onRemoveFilter={onRemoveEvent ? onRemoveFilterHandler : undefined}
        viewMode={viewMode}
      >
        {fields.map((field, index) => {
          return (
            <CohortBuilderInputField
              key={field.id}
              id={field.id}
              label={field.label}
              inputType={field.inputType}
              readOnly={field.readOnly}
              disabled={field.disabled}
              value={field.value}
              onChange={field.onChange}
              width={field.width}
              helperText={field.helperText}
              options={field.options}
              placeholder={field.placeholder}
              minValue={field.minValue}
              minValueMsg={field.minValueMsg}
              maxValue={field.maxValue}
              maxValueMsg={field.maxValueMsg}
              viewMode={viewMode}
              showFieldError={getShouldShowFieldError(modal)}
              updateFieldError={updateFieldError}
              fieldErrorText={intl.formatMessage({
                id: 'projects.cohortBuilderPage.inputFieldError.eventFieldError',
              })}
            />
          );
        })}
        {selection && (
          <RadioButton
            id="cohortBuilderEditModalEvent-radioButton"
            label={selection.label}
            labelSize={RadioButtonSize.SMALL}
            checked={selection.value === 'true'}
            readOnly={selection.readOnly}
            onChange={(_id, _checked) => {
              selection.onChange(_checked ? 'true' : 'false');
            }}
            name="cohortBuilderEditModalEvent-radioButton"
            showBorderBox={false}
            width={selection.width}
            disabled={viewMode}
          />
        )}
      </CohortBuilderEditModalFilter>
    </Tooltip>
  );
};
